export default "__VITE_ASSET__CMgArIId__"